import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/components/Landing";
import Admin from "@/components/admin/Admin";
import ShortApplication from "@/components/apply/ShortApplication";
import BookPage from "@/components/BookPage";

function LandingRoute() {
  return (
    <ReactLenis root options={{ lerp: 0.08, smoothWheel: true, wheelMultiplier: 1 }}>
      <div className="App">
        <Landing />
      </div>
    </ReactLenis>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingRoute />} />
        <Route path="/apply" element={<ShortApplication />} />
        <Route path="/schedule" element={<BookPage />} />
        <Route path="/book" element={<BookPage />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
      <Toaster position="top-center" richColors closeButton />
    </BrowserRouter>
  );
}

export default App;
